import { useState } from 'react';

interface IProps<T, R> {
    method: (props: T) => Promise<R>;
    onSuccess?: (data: R, props: T) => void;
    onError?: (error: any) => void;
    onFinish?: () => void;
}

export const useApiMutation = <T, R>({ method, onError, onSuccess, onFinish }: IProps<T, R>) => {
    const [response, setResponse] = useState<R | undefined>(undefined);
    const [error, setError] = useState<string>();
    const [isLoading, setLoading] = useState(false);

    const handleRequest = async (requestData: T) => {
        setLoading(true);
        setError(undefined);
        return method(requestData)
            .then((result) => {
                setResponse(result);
                if (onSuccess) onSuccess(result, requestData);
                return result;
            })
            .catch((error) => {
                // Do NOT console.log the raw error: secret-bearing mutations (e.g. key
                // rotation) can carry the plaintext secret in the request config/body.
                setError(error?.error_code || '');
                if (onError) onError(error);
            })
            .finally(() => {
                setLoading(false);
                if (onFinish) onFinish();
            });
    };

    return {
        data: response,
        error,
        isLoading,
        handleRequest
    };
};
